import { Icon, IconProps } from ".";

export const Chat = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M20 4H4V17H9V20L13.5 17H20V4Z" />
    </Icon>
  );
};
